// GST rates mapping by country code (Canada, New Zealand, Australia only)
export const getGstRateByCountryCode = [
  { code: 'CA', name: 'Canada' },
  { code: 'NZ', name: 'New Zealand' },
  { code: 'AU', name: 'Australia' },
]
